import { MENU_WIDTH } from '@web-app/components/consts';
import { useShellContributions } from '@web-app/components/Shell/ShellContributions';
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from '@web-app/components/ui/Alert/alert';
import { Button } from '@web-app/components/ui/Button/button';

/** Feature banners above every page with the navbar, in the normal flow. */
export function ShellBanners() {
  const banners = useShellContributions().flatMap(({ banner }) =>
    banner ? [banner] : [],
  );
  if (banners.length === 0) return null;

  return (
    <div style={{ paddingLeft: MENU_WIDTH }}>
      {banners.map((banner) => (
        // A region, not role="alert": it stays up on every page and should not
        // be announced again on each navigation.
        <Alert
          key={banner.id}
          role="region"
          aria-label={banner.title}
          layout="banner"
          className="flex-wrap justify-start gap-4 border-destructive/30 bg-destructive/10 px-10 py-3.5"
        >
          <span
            aria-hidden
            className="flex size-9 shrink-0 items-center justify-center rounded-full bg-destructive text-destructive-foreground [&_svg]:size-[18px]"
          >
            {banner.icon}
          </span>
          <div className="flex min-w-0 flex-1 flex-col">
            <AlertTitle className="line-clamp-none text-[15px] leading-[22px] font-bold text-foreground">
              {banner.title}
            </AlertTitle>
            {banner.description && (
              <AlertDescription className="text-foreground/80">
                {banner.description}
              </AlertDescription>
            )}
          </div>
          <Button variant="destructive" onClick={banner.action.onClick}>
            {banner.action.label}
          </Button>
        </Alert>
      ))}
    </div>
  );
}
